'use client'

import { useAuthenticationToast } from '@/components/AuthenticationToast'

export function ClientSideAuthWrapper() {
  useAuthenticationToast()
  
  return null
}
